import { CloseIcon, Flex } from '@pancakeswap/uikit'
import HeaderIconSearch from '@pancakeswap/uikit/components/Svg/Icons/HeaderIconSearch'
import styled from 'styled-components'
import { Touchable } from 'views/Layout/styled'
import { Input } from '../styled'

const Wrapper = styled(Flex)`
  display: flex;
  width: 100%;
  height: 56px;
  padding: 0px 16px;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  gap: 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`

const SearchInput = ({
  onClose,
  onChangeSearchInput,
}: {
  onClose: () => void
  onChangeSearchInput: (value: string) => void
}) => {
  return (
    <Wrapper>
      <HeaderIconSearch />
      <Input placeholder="Search Alchemy" onChange={(e) => onChangeSearchInput(e.target.value)} />
      <Touchable onClick={onClose}>
        <CloseIcon />
      </Touchable>
    </Wrapper>
  )
}

export default SearchInput
